import React, {useEffect, useMemo, useState} from 'react'
import PropTypes from 'prop-types';
import panels from './part4.panels.components'
import {clearResource, setStepperState} from 'redux/actions'
import {connect} from 'react-redux'
import reduxStore from 'redux/store'
import AccordionPart from "pages/purchaser/MyProcedure/scenes/components/AccordionPart";
import HeaderService from "services/HeaderService";
import createButton, {createSubmitFormButton} from "components/complex/floatingMenu/createButton";
import RouterPath from "libs/RouterPath";
import MailIcon from "@material-ui/icons/Mail";
import ForumIcon from '@material-ui/icons/Forum'
import DemandSectionsService from "services/DemandSectionsService";
import SaveIcon from "@material-ui/icons/Save";
import ArrowIcon from "@material-ui/icons/KeyboardArrowUp";
import ListIcon from "@material-ui/icons/List";
import DemandRelatedObjectsPopup from "components/popup/relatedObjects/DemandRelatedObjectsPopup";
import DemandService from "services/DemandService";
import PrivilegeService from "services/PrivilegeService";
import {DemandValidationKeys} from "constants/DemandValidation";
import {isNationalProcedure} from "constants/ProcedureType";
import Tr from "translations/Translations"

function Part4(
    {
        stepperState,
        setStepperState,
        clearResource,
        steps,
        match,
        demandValidation,
        demandHeader
    }) {
    const id = match.params.id;
    const [working, setWorking] = useState(true);
    const [relatedObjectPopup, setRelatedObjectPopup] = useState(false);

    useEffect(() => {
        const p2 = HeaderService.get(id);
        const p1 = DemandSectionsService.getFinishingSections(id);
        const p3 = DemandService.getBuyerPrivileges(id);
        Promise.all([p1, p2, p3]).then(() => setWorking(false));

        return () => {
            reduxStore.dispatch(setStepperState(null));
            DemandSectionsService.clearDemandValidationResources();
            PrivilegeService.cleanupPrivileges(PrivilegeService.DEMAND_PRIVILEGE_STORE_KEY);
            HeaderService.clear();
        };
        // eslint-disable-next-line
    }, []);

    const navigationBarButtons = () => {
        const buttons = [];
        buttons.push(createButton('email_list', () => {
            const href = RouterPath.createPath(RouterPath.myProcedure.steps.MP_EMAIL_LIST_ID, {id: id});
            RouterPath.redirect(href)
        }, undefined, MailIcon, 'primary', false, true));

        if (!demandHeader || !demandHeader.exPost) {
            buttons.push(createButton('correspondence', () => {
                const href = RouterPath.createPath(RouterPath.myProcedure.steps.MP_CORRESPONDENCE_ID, {id: id});
                RouterPath.redirect(href)
            }, undefined, ForumIcon, 'primary', false, true));

            if (demandHeader && (demandHeader.hasPlanItems || demandHeader.hasPurchaseRequests)) {
                buttons.push(createButton('related_objects', () => setRelatedObjectPopup(true),
                    "outlined", ListIcon, 'primary', false, true));
            }
        }


        const isSaveButton = !!stepperState && (stepperState === "mp_4_demand_plan_realization" || stepperState === "mp_4_finish_additional_info");
        buttons.push(createSubmitFormButton(isSaveButton ? "save" : "close",
            undefined,
            isSaveButton ? SaveIcon : ArrowIcon,
            'primary',
            stepperState === null,
            isSaveButton)
        );

        return buttons;

    };

    const stepsMemo = useMemo(()=> {
        return steps.map(x => x.key === DemandValidationKeys.RESULT_NOTICE && isNationalProcedure(demandHeader?.procedureType) ? {...x, label: Tr("mp_4_result_notice_national")} : x )
    },[demandHeader, steps])


    return (<>
            <AccordionPart working={working} steps={stepsMemo} panels={panels} navigationBarButtons={navigationBarButtons()}/>
            {
                relatedObjectPopup &&
                <DemandRelatedObjectsPopup demandId={id} onClose={() => setRelatedObjectPopup(false)}/>
            }
        </>
    )
}

Part4.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    demandHeader: state.resources.demandHeader,
    stepperState: state.stepper.state,
    steps: state.stepper.steps[3].steps,
    demandValidation: state.resources.demandValidation,
    form: state.form,
}), {
    setStepperState,
    clearResource
})(Part4);